import { useEffect, useState } from 'react';

import ColaboradorFichaje from '@components/Colaboradores/ColaboradorFichajes';
import ColaboradorInfo from '@components/Colaboradores/ColaboradorInfo';
import ColaboradorLegajo from '@components/Colaboradores/ColaboradorLegajo';
import ColaboradorAuditoriaScreen from './ColaboradorAuditoriaScreen';
import Image from '@components/General/Image';
import ColaboradorDedicatedShiftsScreen from './ColaboradorDedicatedShiftsScreen';
import { useLocation } from 'react-router-dom';
import { TabDetailScreenWrapper } from '@components/General/TabDetailScreen';

const ColaboradorControlBoard = ({org}) => {

    const [colaborador, setColaborador] = useState({})
    const [imgUrl, setImgUrl] = useState('');
    const [clickedScreen, setClickedScreen] = useState('perfil')

    const location = useLocation();
    let colaboradorRaw = location.state?.colaborador;

    useEffect(() => {
        if (!colaboradorRaw) return;
    
        setColaborador({ ...colaboradorRaw });
        setImgUrl(colaboradorRaw.photo);        
    }, [colaboradorRaw]);

    const flaps = [
        { 
            id: 'perfil', 
            label: 'Perfil', 
            content: <ColaboradorInfo orgID={org.id} colaborador={colaborador} setColaborador={setColaborador}/>
        },
        { 
            id: 'fichajes', 
            label: 'Fichajes', 
            content: <ColaboradorFichaje orgID={org.id} colaborador={colaborador}/>,
            isLocked: org.newFlags?.LiteVersion 
        },
        { 
            id: 'legajo', 
            label: 'Legajo', 
            content: <ColaboradorLegajo orgID={org.id} colaborador={colaborador}/>,
            isLocked: org.newFlags?.LiteVersion 
        },
        {   
            id: 'auditoria',
            label: 'Auditoria',
            content: <ColaboradorAuditoriaScreen orgID={org.id} colaborador={colaborador}/>,
            isLocked: org.newFlags?.LiteVersion
        },
        org.newFlags?.PresenteeismUserDedicatedShiftsV2 && {
            id: 'turnos-dedicados',
            label: 'Turnos dedicados',
            content: <ColaboradorDedicatedShiftsScreen orgID={org.id} colaborador={colaborador} />,
            isLocked: org.newFlags?.LiteVersion
        }
    ].filter(Boolean)

    


    return (
        <TabDetailScreenWrapper
            title={colaborador.name}
            imgComponent={<Image src={imgUrl} alt="Profile Picture" isRound={true} style={{width: '100%', height: '100%', marginRight: '10px'}}/>}
            flaps={flaps}
            flag={org.flags?.hasWhitelistColaborators}
            clickedScreen={clickedScreen}
            setClickedScreen={setClickedScreen}
        />
    );
};

export default ColaboradorControlBoard
